<div
  class="dialog"
  tabindex="0"
  [cdkTrapFocus]="true"
  [cdkTrapFocusAutoCapture]="true"
>
  <div>
    <header>
      <h1 class="dialog__header">{{ dialogTitle() | translate }}</h1>
    </header>
    <section class="dialog__content">
      <ng-content></ng-content>
    </section>
  </div>
  <footer class="dialog__footer">
    <ng-content select="[dialog-footer]"></ng-content>
  </footer>
</div>
